export function getEndpointUrlFromCanonicalUrl(canonicalUrl: string): string {
    const endIndex: number = findFifthSlashIndex(canonicalUrl);
    return canonicalUrl.substring(0, endIndex);
}

function findFifthSlashIndex(baseString: string): number {
    let n: number = 0;
    for (let i = 0; i < baseString.length; i++) {
        if (baseString[i] === '/') {
            n += 1;
        }
        if (n === 5) {
            return i;
        }
    }

    return -1;
}
